import { render, staticRenderFns } from "./sa-organization-user-create.html?vue&type=template&id=114ec7a0&scoped=true&external"
import script from "./sa-organization-user-create.js?vue&type=script&lang=js&external"
export * from "./sa-organization-user-create.js?vue&type=script&lang=js&external"
import style0 from "./sa-organization-user-create.scss?vue&type=style&index=0&id=114ec7a0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ec7a0",
  null
  
)

export default component.exports